import { render, staticRenderFns } from "./ProductSportsPage.vue?vue&type=template&id=51dbf205&scoped=true&"
import script from "./ProductSportsPage.vue?vue&type=script&lang=js&"
export * from "./ProductSportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dbf205",
  null
  
)

export default component.exports